import { ArrowRight, Menu, X } from "react-feather";
import { Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";

import ClickAwayListener from "react-click-away-listener";
import { GifSend, PngLogo } from "../assets";
import MegaMenu from "./MegaMenu";
import Modal from "react-modal";
import ReactSelect from "react-select";
import emailjs from "@emailjs/browser";
import { megaMenuList } from "../data/megaMenuList";
import { useRef } from "react";

export default function Header({ isOnVerify }) {
  const [nameError, setNameError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [companyError, setCompanyError] = useState("");
  const [titleError, setTitleError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [flavorError, setFlavorError] = useState("");
  const form = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isService, setIsService] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [megaMenuListUpdated, setMegaMenuListUpdated] = useState(megaMenuList);

  useEffect(() => {
    const updateList = () => {
      if (window.innerWidth < 1060) {
        setMegaMenuListUpdated([...megaMenuList]);
      }
      if (window.innerWidth >= 1060) {
        setMegaMenuListUpdated(megaMenuList);
      }
    };
    updateList();
    window.addEventListener("resize", updateList);
  }, []);

  const [serviceName, setServiceName] = useState(megaMenuListUpdated[0].title);

  useEffect(() => {
    setServiceName(megaMenuListUpdated[0].title);
  }, [megaMenuListUpdated]);

  const path = window.location.pathname;

  const handleNameChange = (e) => {
    if (e.target.value === "") {
      setNameError("Name is required");
    } else {
      setNameError("");
    }
  };
  const handleCountryChange = (e) => {
    if (e.target.value === "") {
      setCountryError("Country is required");
    } else {
      setCountryError("");
    }
  };
  const handleEmailChange = (e) => {
    if (e.target.value === "") {
      setEmailError("Email is required");
    } else {
      setEmailError("");
    }
  };
  const handleCompanyChange = (e) => {
    if (e.target.value === "") {
      setCompanyError("Company is required");
    } else {
      setCompanyError("");
    }
  };
  const handleTitleChange = (e) => {
    if (e.target.value === "") {
      setTitleError("Title is required");
    } else {
      setTitleError("");
    }
  };
  const handlePhoneChange = (e) => {
    if (e.target.value === "") {
      setPhoneError("Phone is required");
    } else {
      setPhoneError("");
    }
  };

  const handleCategoriesChange = (e) => {
    if (e.length === 0) {
      setCategoryError("Category is required");
    } else {
      setCategoryError("");
    }
  };

  const handleFlavorChange = (e) => {
    if (e.length === 0) {
      setFlavorError("Flavor is required");
    } else {
      setFlavorError("");
    }
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_pxss1gf",
        "template_le9x0er",
        form.current,
        "7xAcUTkAwtio_EIZ8",
      )
      .then(() => {
        setIsModalOpen(true);
        setIsError(false);
      });
  };

  useEffect(() => {
    setIsService(false);
  }, [path]);

  useEffect(() => {
    if (isModalOpen) {
      const timer = setTimeout(() => {
        setIsModalOpen(false);
        setPopupVisible(false);
      }, 2500);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [isModalOpen]);

  const changeNavState = () => {
    if (window.innerWidth <= 1060) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };
  useEffect(() => {
    changeNavState();
    window.addEventListener("resize", () => {
      changeNavState();
      setIsService(false);
    });
    window.addEventListener("scroll", changeNavState);
  }, []);

  const handleOnClick = (name) => {
    if (window.innerWidth < 1060) {
      setIsOpen(false);
    }
    if (name !== undefined || name !== null) {
      setServiceName(name);
      setIsService(!isService);
    }
  };

  const handleOnHover = (name) => {
    if (window.innerWidth > 1060) {
      setServiceName(name);
      setIsService(true);
    }
  };

  return (
    <>
      <div className="header__content__nav__top__wrapper">
        <div className="mainheader__bar__top">
          <div className="mainheader__bar__top__heading">
            Welcome to Knights Home Service
            <NavLink className="mainheader__bar__top__heading__navlink">
              Learn More Here!
              <ArrowRight
                style={{
                  color: "#fff",
                  width: "20px",
                  height: "20px",
                }}
              />
            </NavLink>
            <NavLink
              className="mainheader__bar__top__heading__navlink__mobile"
              to="/who-we-are"
            >
              {" "}
              Learn More Here! →
            </NavLink>
          </div>
        </div>
      </div>

      <div
        onMouseLeave={() => {
          if (window.innerWidth > 1060) {
            setIsService(false);
          }
        }}
      >
        <div
          className={
            isOnVerify || isService ? "header header__active" : "header"
          }
          style={
            isOpen && window.innerWidth < 1060
              ? {
                  backgroundColor: "#f9a825",
                }
              : {}
          }
        >
          <div className="header__content">
            <Link
              to="/"
              className="header__content__logo"
              title="Knights Home Service"
            >
              <img
                className="header__content__logo__img"
                src={PngLogo}
                alt="logo"
              />
            </Link>
            {isOpen ? (
              <div className="header__content__nav">
                {megaMenuListUpdated.map((item) => (
                  <Link
                    key={item.title}
                    to={item.link}
                    className={
                      isService
                        ? "header__content__nav__link header__content__nav__link__active"
                        : "header__content__nav__link"
                    }
                    onClick={() => handleOnClick(item.title)}
                    onMouseOver={() => handleOnHover(item.title)}
                  >
                    {item.title}
                  </Link>
                ))}
                <div className="mobilemenu">
                  {/* <Link
                    className={`header__content__nav__top__left__link ${
                      isService
                        ? "header__content__nav__top__left__link__active"
                        : ""
                    }`}
                    onClick={() => {
                      if (window.innerWidth < 1060) {
                        setIsOpen(false);
                      }
                    }}
                    to="/register?role=End-Customer"
                  >
                    Registration
                  </Link>
                  <Link
                    className={`header__content__nav__top__left__link ${
                      isService
                        ? "header__content__nav__top__left__link__active"
                        : ""
                    }`}
                    to="/careers"
                    onClick={() => {
                      if (window.innerWidth < 1060) {
                        setIsOpen(false);
                      }
                    }}
                  >
                    Careers
                  </Link> */}
                </div>
                <div className="header__content__nav__linkbtn__div">
                  <button
                    onClick={() => {
                      setPopupVisible(true);
                      setIsOpen(false);
                    }}
                    title="Request a Sample"
                    className="header__content__nav__linkbtn"
                  >
                    Contact us
                  </button>
                </div>
              </div>
            ) : null}
            <div className="header__content__cta">
              <button
                className="header__content__menu"
                onClick={() => setIsOpen(!isOpen)}
                title={isOpen ? "Close" : "Open"}
              >
                {isOpen ? (
                  <X size={20} color="currentColor" />
                ) : (
                  <Menu size={20} color="currentColor" />
                )}
              </button>
            </div>
          </div>
        </div>
        {isService ? (
          <MegaMenu
            onClickAway={() => {
              setIsService(false);
            }}
            data={
              megaMenuListUpdated.find((item) => item.title === serviceName)
                .children
            }
          />
        ) : null}
        {isOpen && window.innerWidth <= 1060 ? (
          <div
            style={{
              position: "fixed",
              top: 0,
              width: "100%",
              height: "100vh",
              zIndex: 888,
            }}
            onClick={() => {
              setIsOpen(false);
            }}
          />
        ) : null}
        {popupVisible && (
          <ClickAwayListener onClickAway={() => setPopupVisible(false)}>
            <div className="popup">
              <div className="popup-content">
                <div className="text___button__popup">
                  <div className="text___button__popup__heading">
                    Contact Form
                  </div>
                  <button
                    type="button"
                    title="Close"
                    className="close-button"
                    onClick={() => setPopupVisible(false)}
                  >
                    X
                  </button>
                </div>
                <form
                  ref={form}
                  onSubmit={sendEmail}
                  className="contact__content__left__popup contact__content__left__reverse"
                >
                  <Input
                    id="name"
                    type="name"
                    label="Name"
                    name="name"
                    title="Name"
                    required={true}
                    onChange={handleNameChange}
                    error={nameError}
                  />
                  <Input
                    type="title"
                    name="title"
                    label="Title "
                    title="Position"
                    required={true}
                    onChange={handleTitleChange}
                    error={titleError}
                  />

                  <Selectt
                    label="Categories"
                    name="Categories"
                    title="Categories"
                    placeholder="Select Categories"
                    options={[
                      {
                        value: "Window Cleaning",
                        label: "Window Cleaning",
                      },
                      {
                        value: "Roof Cleaning",
                        label: "Roof Cleaning",
                      },
                      {
                        value: "Gutter Cleaning",
                        label: "Gutter Cleaning",
                      },
                      {
                        value: "Other",
                        label: "Other",
                      },
                    ]}
                    onChange={handleCategoriesChange}
                    error={categoryError}
                  />

                  <Input
                    type="Email"
                    label="Email"
                    title="Email"
                    name="Email"
                    required={true}
                    onChange={handleEmailChange}
                    error={emailError}
                  />
                  <Input
                    type="tel"
                    name="tel"
                    label="Phone Number"
                    title="Phone"
                    required={true}
                    onChange={handlePhoneChange}
                    error={phoneError}
                  />
                  <button
                    type="submit"
                    value="Send"
                    title="Submit"
                    className="contact__content__left__button"
                  >
                    Request
                  </button>
                </form>
                <Modal
                  isOpen={isModalOpen}
                  contentLabel="Form Submission Status"
                >
                  <div
                    className={`modal-content ${isError ? "error" : "success"}`}
                  >
                    <img
                      loading="lazy"
                      alt="img"
                      src={GifSend}
                      className="sendgif"
                    />
                    <h2>
                      {isError
                        ? "Error submitting the form."
                        : " We have received your request successfully. We will contact you soon."}
                    </h2>
                  </div>
                </Modal>
              </div>
            </div>
          </ClickAwayListener>
        )}
      </div>
    </>
  );
}

function Input({ textarea, required, label, error, list, ...props }) {
  return (
    <div className="contact__content__left__input">
      <label
        htmlFor={props.id}
        className="contact__content__left__input__label"
      >
        {label}
        {required ? <span>*</span> : null}
      </label>
      {textarea ? (
        <textarea
          {...props}
          cols="30"
          rows="10"
          className="contact__content__left__input__field"
          required={required}
          style={{ padding: "1em" }}
        />
      ) : (
        <input
          {...props}
          className="contact__content__left__input__field"
          required={required}
          list={label + "s"}
          id={label}
        />
      )}
      {error !== "" ? (
        <div className="contact__content__left__input__error">{error}</div>
      ) : null}
      {list ? (
        <datalist className="datalist" id={label + "s"}>
          {list.map((item, i) => (
            <option className="options" key={i} value={item} />
          ))}
        </datalist>
      ) : null}
    </div>
  );
}
function Selectt({ label, id, error, ...props }) {
  return (
    <div className="container__main__content__details__main__input">
      <label
        htmlFor={id}
        className="container__main__content__details__main__input__label"
      >
        {label}
      </label>
      <div className="container__main__content__listing__header__left__filter container__main__content__listing__header__left__filter__special">
        <ReactSelect
          {...props}
          styles={{
            control: (provided) => ({
              ...provided,
              backgroundColor: "transparent",
              padding: "0.25em 0",
              border: "1px solid black",
            }),
          }}
          theme={(theme) => ({
            ...theme,
            borderRadius: 5,

            colors: {
              ...theme.colors,
              primary75: "#f9a825",
              primary25: "#f9a8255e",
              primary50: "#f9a8255e",
              primary: "#f9a825",
            },
          })}
        />
      </div>
      {error && (
        <div className="container__main__content__details__main__input__error">
          {error}
        </div>
      )}
    </div>
  );
}

function PopupButton({ setPopupVisible, setIsOpen }) {
  return (
    <button
      onClick={() => {
        setPopupVisible(true);
        setIsOpen(false);
      }}
      title="Request a Sample"
      className="header__content__nav__linkbtn"
    >
      Contact us
    </button>
  );
}
